import React, { useMemo, useState } from "react";
import { Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { DatePicker } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoCalendar, IoChevronDown } from "react-icons/io5";
import "./datepickerStyles.css";
import { func, number, object, string, bool } from "prop-types";
import { getMinDate, getMaxDate } from "@/utils";

interface NewDatePickerProps {
  getSelectedDate: (dates: [Date | null, Date | null], segment: string) => void;
  onSegmentChange: (segment: number) => void;
  gettext?: (key: string) => string;
  segment?: number;
  selectededDate?: { startDate?: string | Date; endDate?: string | Date };
  view?: string;
  futureDates?: boolean | number;
  pastYears?: number;
  futureYears?: number;
  minDate?: Date;
  maxDate?: Date;
  disableSegments?: boolean | string[];
}

const NewDatePicker = (props: NewDatePickerProps) => {
  const {
    getSelectedDate,
    onSegmentChange,
    gettext,
    segment,
    selectededDate,
    view,
    futureDates,
    disableSegments,
  } = props;

  const [newSelectedSegment, setNewSelectedSegment] = useState("");
  //  const [selectedDate, setSelectedDate] = useState(
  //    selectededDate?.date ? new Date(selectededDate?.date) : new Date()
  //  );

  const [startDate, setStartDate] = useState(
    selectededDate?.startDate
      ? new Date(selectededDate?.startDate)
      : new Date(),
  );
  const [endDate, setEndDate] = useState(
    selectededDate?.endDate ? new Date(selectededDate?.endDate) : new Date(),
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const selectedSegment = useMemo(() => {
    let returnValue;

    if (newSelectedSegment) {
      returnValue = newSelectedSegment;
    } else if (segment === 0) {
      returnValue = "day";
    } else if (segment === 1) {
      returnValue = "month";
    } else {
      returnValue = "year";
    }
    return returnValue;
  }, [newSelectedSegment, segment]);

  const handleSegmentClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSegmentClose = () => {
    setAnchorEl(null);
  };
  const handleDateChange = (event: [Date | null, Date | null]) => {
    const [start, end] = event;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      // setSelectedDate(event);
      getSelectedDate(event, selectedSegment);
      handleSegmentClose();
    }
  };

  const handleSegmentSelect = (segment: string) => {
    setNewSelectedSegment(segment);
    if (segment === "day") {
      onSegmentChange(0);
    } else if (segment === "month") {
      onSegmentChange(1);
    } else {
      onSegmentChange(2);
    }
    handleSegmentClose();
  };

  const formattedDate = () => {
    let dateStart;
    let dateEnd;
    // if(selectedDate) {
    //   date = new Date(selectedDate);
    // } else {
    dateStart = new Date(startDate);
    dateEnd = new Date(endDate);
    // }

    const dayStart = dateStart.getDate();
    const monthStart = dateStart.toLocaleString("default", {
      month: "short",
    });
    const yearStart = dateStart.getFullYear();

    const dayEnd = dateEnd.getDate();
    const monthEnd = dateEnd.toLocaleString("default", {
      month: "short",
    });
    const yearEnd = dateEnd.getFullYear();

    if (selectedSegment === "year") {
      return `${yearStart} - ${yearEnd}`;
    } else if (selectedSegment === "month") {
      return `${monthStart} ${yearStart} - ${monthEnd} ${yearEnd}`;
    } else {
      return `${dayStart} ${monthStart} ${yearStart} - ${dayEnd} ${monthEnd} ${yearEnd}`;
    }
  };

  const renderDatePicker = () => {
    switch (selectedSegment) {
      case "year":
        return (
          <DatePicker
            className="my-datepicker"
            //            selected={selectedDate}
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
            dateFormat="yyyy"
            showMonthDropdown={false}
            showYearPicker
            dropdownMode="select"
            selectsRange
            inline
            // minDate={
            //     futureDates === false &&
            //     new Date().setMonth(new Date().getMonth())
            // }
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate || getMaxDate(props.futureYears ?? futureDates)
            }

            dayClassName={(date) => {
              return date.getMonth() !== startDate.getMonth() ? "disabled" : "";
            }}
          />
        );
      case "month":
        return (
          <DatePicker
            className="my-datepicker"
            // selected={selectedDate}
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            selectsRange
            inline
            // minDate={
            //     futureDates === false &&
            //     new Date().setMonth(new Date().getMonth())
            // }
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate || getMaxDate(props.futureYears ?? futureDates)
            }
            dayClassName={(date) => {
              return date.getMonth() !== startDate.getMonth() ||
                date.getFullYear() !== startDate.getFullYear()
                ? "disabled"
                : "";
            }}
          />
        );
      case "day":
      default:
        return (
          <DatePicker
            // className="my-datepicker"
            // selected={selectedDate}
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
            dateFormat="dd MMMM yyyy"
            selectsRange
            inline
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate || getMaxDate(props.futureYears ?? futureDates)
            }
            dayClassName={(date) => {
              return date.getMonth() !== startDate.getMonth() ? "disabled" : "";
            }}
          />
        );
    }
  };

  // const getSelectedSegment = useCallback(() => {
  //   if (segment === 0) {
  //     setSelectedSegment("day");
  //   } else if (segment === 1) {
  //     setSelectedSegment("month");
  //   } else {
  //     setSelectedSegment("year");
  //   }
  // }, [segment]);
  //
  // useEffect(() => {
  //   getSelectedSegment();
  // }, [segment, getSelectedSegment]);

  // useEffect(() => {
  //   if (segment === 0) {
  //     setSelectedSegment("day");
  //   } else if (segment === 1) {
  //     setSelectedSegment("month");
  //   } else {
  //     setSelectedSegment("year");
  //   }
  // }, [segment]);

  return (
    <>
      {view === "table" ? (
        <Button
          endIcon={<IoChevronDown size={12} />}
          size="small"
          onClick={handleSegmentClick}
          sx={{
            width: "160px",
            "&:hover": {
              backgroundColor: "#fff",
              border: "1px solid #E4E4E7",
            },
          }}
        >
          <Typography
            sx={{ fontSize: "14px", fontWeight: "500", color: "secondary.800" }}
          >
            Calender
          </Typography>
        </Button>
      ) : (
        <Button
          variant="contained"
          size="small"
          style={{
            height: "32px",
          }}
          endIcon={<IoCalendar />}
          onClick={handleSegmentClick}
          sx={{ color: "secondary" }}
        >
          <Typography sx={{ fontSize: "14px", fontWeight: "fontWeightMedium" }}>
            {formattedDate()}
          </Typography>
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleSegmentClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          ".MuiMenu-list": {
            padding: 0,
            height: "100%",
          },
          "& .MuiMenu-paper": {
            width: "412px",
            borderRadius: "8px",
            boxShadow:
              "0px 10px 15px -3px #0000001A ,0px 4px 6px -2px #0000000F",
            overflow: "hidden",
          },
          "& .MuiMenuItem-root": {
            fontWeight: 400,
            fontSize: "14px",
          },
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: "secondary.900",
            fontWeight: 600,
            fontSize: "14px",
            color: "white",
          },
        }}
      >
        {/*<Grid container columnSpacing={1} xs={12}>*/}
        <Grid container columnSpacing={1}>
          <Grid
            size={{ xs: 4 }}
            sx={{
              borderRight: "1px solid #E4E4E7",
            }}
          >
            <MenuItem
              disabled={disableSegments && segment !== 0}
              selected={selectedSegment === "day"}
              onClick={() => handleSegmentSelect("day")}
            >
              {gettext("Daily")}
            </MenuItem>
            <MenuItem
              disabled={disableSegments && segment !== 1}
              selected={selectedSegment === "month"}
              onClick={() => handleSegmentSelect("month")}
            >
              {gettext("Monthly")}
            </MenuItem>
            <MenuItem
              disabled={disableSegments && segment !== 2}
              selected={selectedSegment === "year"}
              onClick={() => handleSegmentSelect("year")}
            >
              {gettext("Yearly")}
            </MenuItem>
          </Grid>
          <Grid size={{ xs: 8 }}>{renderDatePicker()}</Grid>
        </Grid>
      </Menu>
    </>
  );
};

NewDatePicker.propTypes = {
  getSelectedDate: func,
  onSegmentChange: func,
  gettext: func,
  segment: number,
  selectededDate: object,
  view: string,
  futureDates: bool,
  disableSegments: bool,
};

export default NewDatePicker;
